import React, { useCallback, useState } from "react";
import PageHeader from "../../Components/Common/PageHeader";
import { faPaypal } from "@fortawesome/free-brands-svg-icons";
import PaypalAccountsBlock from "../../Components/PaypalAccounts";
import PaypalTools from "../../Components/PaypalAccounts/PaypalTools";

const Gateways = () => {
  const [accountList, setAccountList] = useState([]);
  const handleAccountsChange = useCallback((list) => setAccountList(list), []);

  return (
    <main className="page-main">
      <div className="main-container container">
        <PageHeader
          title="PayPal"
          description="Quản lý cổng thanh toán PayPal và các công cụ export."
          icon={faPaypal}
        />

        <PaypalAccountsBlock onAccountsChange={handleAccountsChange} />
        <PaypalTools accountList={accountList} />
      </div>
    </main>
  );
};

export default Gateways;
